import Calendar from "react-calendar";
import { format } from "date-fns";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";

const CustomCalendar = ({
  selectedDate,
  handleDateChange,
}) => {
  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="p-4">
        <Calendar
          onChange={handleDateChange}
          value={selectedDate}
          className="premium-calendar"
          prevLabel={
            <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white transition-all duration-200 hover:border-primary-color hover:bg-blue-50 hover:text-primary-color">
              <FaArrowLeft size={14} />
            </span>
          }
          nextLabel={
            <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white transition-all duration-200 hover:border-primary-color hover:bg-blue-50 hover:text-primary-color">
              <FaArrowRight size={14} />
            </span>
          }
          prev2Label={null}
          next2Label={null}
          tileClassName={({ date }) => {
            const isToday =
              format(date, "yyyy-MM-dd") ===
              format(new Date(), "yyyy-MM-dd");

            const isSelected =
              format(date, "yyyy-MM-dd") ===
              format(selectedDate, "yyyy-MM-dd");

            if (isSelected) return "calendar-selected";
            if (isToday) return "calendar-today";

            return "calendar-day";
          }}
        />
      </div>
    </div>
  );
};

export default CustomCalendar;